import $ from 'jquery';

export const phoneRequired = () => {
  $('form[name="O_Cignacom_030418_Notifications_Form"] #contact-checkbox').click(() => {
    $('.business-phone-input').toggleClass('d-none');
    $('.contact-disclaimer').toggleClass('d-none');
  });
};

const setFMLASuccessMsg = () => {
  const solutionsId = $('form[name="CGI-FMLA-ADA"] select[id^="Solutions"]');
  $('form[name="CGI-FMLA-ADA"]').on('submit', () => {
    if ($(solutionsId).find(':selected').attr('id') === 'fmla') {
      $('#fmlaSuccess').attr('class', 'd-block');
      $('#normalSuccess').attr('class', 'd-none');
    }
  });
};

export default () => {
  phoneRequired();
  setFMLASuccessMsg();
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/form-eloqua.js